module.exports = __webpack_public_path__ + "img/10.1bca0b39.jpg";